// extracted by mini-css-extract-plugin
module.exports = {"HeaderBlockCarousel":"HeaderBlockWithCarousel_HeaderBlockCarousel__UPOTo"};